var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ElectronicWallet"},[(_vm.isOpen && _vm.walletInfo)?_c('Opened',{ref:"wallet-open",on:{"refreshPage":_vm.refreshPage}}):_c('NotOpen',{attrs:{"is-real-name":_vm.isRealName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }